import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/flightFareOptions', request)
}

export {get}
